export const environment = {
  production: false,
  baseURI:"https://papapi.dev.dctinc.net",
  // baseURI:"https://5eu3lc2izd.execute-api.us-west-2.amazonaws.com", QA
  apiUrl: "/admin/",
  micrositeUrl:"https://papmicrosite.dev.dctinc.net",
  loginUrl: "/auth/login",
  patientSpeakerUrl: "/patientspeaker",
  forgotPasswordUrl: "/auth/forgotPassword",
  resetPasswordUrl: '/auth/resetPassword',
  getAllSeriesUrl:"getAllSeries",
  getAllProductsUrl:"getAllProducts",
  getAllTopicsUrl:"getAllTopics",
  getAllProgramTypeUrl:"getAllProgramType",
  getAllMealTypeUrl:"getAllMealType",
  storyTypeUrl: '/',
  getAllSalesrep:'getAllSalesRep',
  createEventUrl:"events/create",
  updateEventUrl:"events/update",
  getEventDetails:"events/",
  updateEventSpeakerUrl:"events/updateEventSpeaker",
  updateEventVenueUrl:"events/updateEventVenue",
  submitEventUrl:"events/submitEvent",
  getAllTrainingMaterialUrl: 'training/getAllMaterials',
  getInitiateSpeakerListUrl: 'training/getInitiateSpeakerList',
  assignToSpeakerUrl: 'training/assignToSpeaker',
  deleteEventUrl:"events/delete",
  updateEventStatusUrl:"events/updateEventStatus",
  getAllEventStatusUrl:"getAllEventStatus",
  getHcpSpeakerNamesUrl:"events/getAllHcpSpeaker",
  addAuditTrailUrl:"events/addAuditTrail",
  changePassword: '/auth/changePassword',
  reportTypeUrl:'reports/getReportType',
  eventListUrl:'reports/getEventList',
  attendeesReportUrl:'reports/attendees',
  allQuestionsUrl:'reports/getAllQuestions',
  notOnTreatmentReportUrl:'reports/notOnTreatment',
  optInReportUrl:'reports/optIn',
  markettingReportUrl:'reports/marketting',
  tllReportUrl:'reports/tll',
  ghostReportUrl:'reports/ghostregistrants',
  sendAttendeeEventReminderUrl:'events/sendAttendeeReminderEmail',
  micrositeQuestionOptionsUrl:'/microsite/questions/questionswithoptions',
  accessKey: 'AKIA3IIV2AWGVGHEXEES',
  secretAccessKey: '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',
  region: 'us-east-1',
  bucket: 'pap-content',


};
